module.exports = {
	"en": {
		"conversation": {
			"widget": {
				"title": "Chat with us"
			}
		}
	}
};